import React from "react";
import AboutServices from "../../../PIForm/Steps/step5/stepFiveForm";
import { Wrapper } from "./styles";
import {
  getClientTypeIdFromOnboardingToken,
  redirectToPiOnboardingIdentification,
} from "../helpers";
import { useNavigateAfterReload } from "../../../../hooks/useNavigateAfterReload";

function About() {
  useNavigateAfterReload();
  const onboardingToken = sessionStorage.getItem("onboardingToken");

  if (!onboardingToken) {
    redirectToPiOnboardingIdentification();
  }

  const clientTypeId = getClientTypeIdFromOnboardingToken();

  return (
    <Wrapper>
      <AboutServices clientTypeId={clientTypeId} />
    </Wrapper>
  );
}

export default About;
